import { render, staticRenderFns } from "./UnloadingOrderStats.vue?vue&type=template&id=318f4304&scoped=true"
import script from "./UnloadingOrderStats.vue?vue&type=script&lang=js"
export * from "./UnloadingOrderStats.vue?vue&type=script&lang=js"
import style0 from "./UnloadingOrderStats.vue?vue&type=style&index=0&id=318f4304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318f4304",
  null
  
)

export default component.exports